/**
 * Vitals Visibility Configuration
 *
 * Controls which vital signs are rendered in the resident detail modal.
 * Set a vital to `false` to hide it from both the trend charts and the table view.
 */

export interface VitalsVisibilityConfig {
  bloodPressure: boolean;
  heartRate: boolean;
  temperature: boolean;
  oxygenSaturation: boolean;
  weight: boolean;
  respiration: boolean;
  painLevel: boolean;
  bmi: boolean;
  bloodGlucose: boolean;
  height: boolean;
  levelOfConsciousness: boolean;
}

export const VITALS_VISIBILITY: VitalsVisibilityConfig = {
  bloodPressure: true,
  heartRate: true,
  temperature: true,
  oxygenSaturation: true,
  weight: true,
  respiration: true,
  painLevel: true,
  bmi: false,
  bloodGlucose: true,
  height: true,
  levelOfConsciousness: true,
};
